import PubSub from "pubsub-js";
import AccountData from "./shared/account/account-data/account-data";
import ECommerce from "./shared/e-commerce/e-commerce";
import SideNav from "./shared/menu/sidenav";
import ResizeObserver from "./shared/resize-observer/resize-observer";

/**
 * Layout Component
 * If needed to apply global JS on page at start (before loading components)
 * Also used to load shared css 'layout'
 */
export default class Layout {
    constructor () {
        PubSub.subscribe('mounted', this.mounted.bind(this))
    }

    /**
     * All components are mounted
     */
    mounted () {
        const observables = document.querySelectorAll("[data-resize-observer]");
        if (observables.length > 0) {
            window.observer = new ResizeObserver();
            observables.forEach((observable:HTMLElement) => {
                window.observer.observe(observable);
            })
            window.observer.launch();
            window.addEventListener("resize", () => {
                window.observer.launch();
            })
        }
        if (window.innerWidth < 767) {
            new SideNav()
        }
        new ECommerce();
        new AccountData();
    }

}